import { call, takeLatest, put, select } from 'redux-saga/effects'
import { get, find } from 'lodash'
import api from '~/helpers/api'
import { Types as PanoramaTypes, Creators as PanoramaActions } from '../ducks/panoramas'
import { Creators as FlashMessageActions } from '../ducks/flashMessage'

const optionsSelector = ({ panorama }) => panorama.options

function* getPanoramas() {
    const options = yield select(optionsSelector)
    const getFilter = (property) => {
        const filterValue = find(options.filters, { name: property })
        return filterValue.value
    }

    const search = []
    if (options.search) {
        search.push(`name,${options.search}`)
        search.push(`id,${options.search}`)
    }

    try {
        const { data } = yield call(api.get, 'panorama', {
            params: {
                'department_id': getFilter('department_id'),
                search,
                page: options.page + 1,
                order: `${options.sort},${options.direction}`,
            },
        })

        yield put(PanoramaActions.getPanoramasSuccess(data.data, data.total))
    } catch (e) {
        yield put(PanoramaActions.getPanoramasFailure())
    }
}

function* reloadPanoramas() {
    yield put(PanoramaActions.getPanoramasRequest())
}

function* getAllDepartments() {
    try {
        const { data } = yield call(api.get, `departments`, {
            params: {
                pagination: 0,
                order: 'name,asc',
            },
        })

        yield put(PanoramaActions.getPanoramasAllDepartmentsSuccess(data))
    } catch (e) {
        yield put(PanoramaActions.getPanoramasAllDepartmentsFailure())
        const error = get(e, 'response.data.error[0]')
        yield put(
            FlashMessageActions.showMessage({
                message: error || 'Ops! Algo deu errado. Tente novamente',
                variant: 'error',
            }),
        )
    }
}

export default function* () {
    yield takeLatest(PanoramaTypes.GET_PANORAMAS_REQUEST, getPanoramas)
    yield takeLatest(PanoramaTypes.SET_PANORAMAS_SORT, reloadPanoramas)
    yield takeLatest(PanoramaTypes.SET_PANORAMAS_PAGE, reloadPanoramas)
    yield takeLatest(PanoramaTypes.GET_PANORAMAS_ALL_DEPARTMENTS_REQUEST, getAllDepartments)
    yield takeLatest(PanoramaTypes.SET_PANORAMAS_PROPERTY_FILTER, reloadPanoramas)
}
